import * as React from 'react';
import { AppPopupsLayer } from './AppPopupsLayer';
import { AppIntegrationsLayer } from './AppIntegrationsLayer';
import { AppCasinoLayer } from './AppCasinoLayer';

export const AppGlobalLayers = (): JSX.Element => (
    <>
        <AppPopupsLayer />
        <AppIntegrationsLayer />
        <AppCasinoLayer />
    </>
);
